import { DataBean } from "../DataBean";

export class RequestMaintenance extends DataBean {

  public async getRequestMaintenanceCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getRequestMaintenanceCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getFixedAssetItemsMaintenablesRender( page: number, row: number, props: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getFixedAssetItemsMaintenablesRender_Number_Number_java.util.Map",
      [page, row, props]
    );
  }

  public async getRequestMaintenanceRender( page: number, row: number, props: any , fromDate: any, uptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getRequestMaintenanceRender_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, row, props, fromDate, uptoDate]
    );
  }

  public async getRequestMaintenanceStats( page: number, row: number, props: any , fromDate: any, uptoDate: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getRequestMaintenanceStats_Number_Number_java.util.Map_java.util.Date_java.util.Date",
      [page, row, props, fromDate, uptoDate]
    );
  }

  public async deleteRequestMaintenance(idrequestmaintenance: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteRequestMaintenance_Number", [idrequestmaintenance]);
  }

  public async updateRequestMaintenance(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.RequestMaintenance_updateRequestMaintenance_com.orange.finance.processcontract.bean.RequestMaintenance",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.RequestMaintenance",
        },
      ]
    );
  }
}
